const mockAgents = [
    {
      id: "1",
      name: "Dr. K H Lasantha Goonewardena",
      specialty: "Managing Diretor & Realtor",
      email: "chairman@raytronics.lk",
      phone: "+94777727527",
      imageUrl: "https://i.imgur.com/rdU5cbb.jpeg", // Replace with actual image paths
      describe: 'A visionary leader committed to sustainable real estate development and innovation.',

    },
    {
      id: "2",
      name: "Dan Yabesh Poddiwela",
      specialty: "Realtor",
      email: "sales@raytronics.lk",
      phone: "+94771125807",
      imageUrl: "https://i.imgur.com/2tS1fH7.jpeg", // Replace with actual image paths
      describe: 'Dedicated to providing exceptional service and finding dream homes for clients.',

    },
    {
      id: "3",
      name: "Shamika Chandupa Manikrathne",
      specialty: "Social Media Strategist",
      email: "sales@raytronics.lk",
      phone: "+94726645529",
      imageUrl: "https://i.imgur.com/Pg3lwxo.jpeg", // Replace with actual image paths
      describe: "Combines graphic design expertise with strategic marketing for impactful campaigns.",
    },
  ];
  
  export default mockAgents;
  